import { Badge } from "@deere/fuel-react";
import {
  Cancel,
  CheckCircle,
  DirectionsRun,
  EventBusy,
  TimerOffOutlined,
} from "@mui/icons-material";
import { SvgIcon, SvgIconProps } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { OrderStatus } from "../../types";

interface OrderStatusIconInfo {
  icon: React.ReactElement;
  variant?: "error" | "warning" | "info" | "success" | undefined;
  badgeSx?: {};
}

const CheckIcon: FC<SvgIconProps> = (props) => (
  <SvgIcon
    {...props}
    arial-label="Done Icon"
    role="img"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      d="M6.00262 10.3128L13.0737 3.24169L14.4879 4.65591L6.00262 13.1412L5.57129 12.7099L1.80005 8.93862L3.21426 7.5244L6.00262 10.3128Z"
      fill="#367C2B"
    />
  </SvgIcon>
);

const OrderStatusBadge = ({ status }: { status: OrderStatus }) => {
  const theme = useTheme();
  const { t } = useTranslation("orders");

  const iconMap: { [key in OrderStatus]: OrderStatusIconInfo } = {
    [OrderStatus.UNSUBMITTED]: { icon: <EventBusy /> },
    [OrderStatus.SUBMITTED]: { icon: <CheckIcon />, variant: "success" },
    [OrderStatus.CANCELLED]: { icon: <Cancel />, variant: "error" },
    [OrderStatus.IN_PROCESS]: { icon: <DirectionsRun />, variant: "info" },
    [OrderStatus.ON_HOLD]: {
      icon: <TimerOffOutlined />,
      variant: "warning",
    },
    [OrderStatus.COMPLETED]: {
      icon: (
        <CheckCircle
          sx={{ color: `${theme.tokens.FuelColorWhite} !important` }}
        />
      ),
      badgeSx: {
        bgcolor: theme.tokens.FuelColorAlertSuccessIcon,
        color: theme.tokens.FuelColorWhite,
      },
    },
  };
  const iconInfo = iconMap[status];
  if (!iconInfo) {
    return null;
  }
  const { icon, variant, badgeSx } = iconInfo;

  return (
    <Badge
      startIcon={icon}
      variant={variant}
      sx={badgeSx}
      data-testid="order-status-badge"
    >
      {t(`orders:orderStatus.${OrderStatus[status]}`)}
    </Badge>
  );
};

export default OrderStatusBadge;
